<template>
  <div class="foot mainBackground">
    <div class="btn-wrap">
      <!-- <el-button
        v-if="show && !$route.query.type && !$route.query.id"
        size="mini"
        :disabled="startDisabled"
        @click="start"
        >开始录制</el-button
      >
      <el-button
        v-if="show && !$route.query.type && !$route.query.id"
        size="mini"
        :disabled="endDisabled"
        @click="end"
        >停止录制</el-button
      >
      <el-button
        size="mini"
        v-if="endDisabled && !$route.query.type && !$route.query.id"
        @click="play"
        >播放</el-button
      >
      <audio
        :src="url"
        controls
        style="width:80%"
        v-if="$route.query.id && url"
      ></audio>
      <audio
        controls
        autoplay
        style="width:80%"
        v-if="endDisabled && !$route.query.type && !$route.query.id"
      ></audio> -->
    </div>
    <span></span>
  </div>
</template>

<script>
import { uploadFile } from "../utils/mmse.js";
var recorder;
export default {
  name: "VueFooter",
  props: {
    show: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    url: {
      type: String,
      default: () => {
        return "";
      },
    },
  },
  data() {
    return {
      startDisabled: false,
      endDisabled: false,
      uploadMsg: "",
    };
  },
  methods: {
    play() {
      var audio = document.querySelector("audio");
      if (this.url) {
        audio.src = this.url;
        return;
      }
      recorder.play(audio);
    },
    start() {
      this.startDisabled = true;
      HZRecorder.get(function (rec) {
        recorder = rec;
        recorder.start();
      });
    },
    end() {
      this.endDisabled = true;
      recorder.stop();
      let fd = new FormData();
      fd.append("file", recorder.getBlob());
      uploadFile(fd).then((res) => {
        this.uploadMsg = res.msg;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.foot {
  position: fixed;
  bottom: 0px;
  left: 0px;
  height: 60px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
  background-color: #fff;
  font-size: 14px;

  z-index: 21;
  .btn-wrap {
    display: flex;
    width: 100%;
    justify-content: center;
  }
  audio {
    height: 30px;
    margin-left: 10px;
  }
}
.mainBackground {
  color:#fff ;
  background: #4F585F !important;
  // border-color: rgba(2, 72, 167);
}
</style>
